/* js/filterBox.js */

jQuery( document ).ready(function( $ ) {

    $( ".filterBoxForm input" ).change(function() {
        var tagtext = $(this).val();

        $('.filterTagGroup')
            .append( '<div class="filterTag"><span class="filterTag__name">'+tagtext+'</span><span class="filterTag__icon js-filterTag-remove" data-tagname="'+tagtext+'"><i class="material-icons"  >close</i></span></div>' );

    });



    $( ".filterBoxForm .selectBox" ).on('change', function() {


        var tagtext = ( this.value );

        console.log(tagtext);

        $('.filterTagGroup')
            .append( '<div class="filterTag"><span class="filterTag__name">'+tagtext+'</span><span class="filterTag__icon js-filterTag-remove" data-tagname="'+tagtext+'"><i class="material-icons"  >close</i></span></div>' );

    });




    $('body').on('click', '.js-filterTag-remove', function() {

        var tagname = $(this).data('tagname');
        console.log(tagname);
        $('input[value="'+tagname+'"]').prop('checked', false);


       /*var selectVal = $( ".filterBoxForm .selectBox" ).val();

       console.log(selectVal);*/







        if($( ".filterBoxForm .selectBox" ).val() === tagname){
            $( ".filterBoxForm .selectBox option:selected" ).prop("selected", false).parent().removeClass('forminput-not-empty');

        }

        $(this).parent().fadeOut();
    });






    $('.js-triggerFilter').click(function () {
        $('body').addClass('filterBox-open');
    });

    $('.js-filterClose').click(function () {
        $('body').removeClass('filterBox-open');
    });







});